import { createPinia, storeToRefs, type Store } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import useUserStore from './modules/user'
import useSysStore from './modules/sys'
import usePersistStore from './modules/persist'

export {
  useUserStore,
  useSysStore,
  usePersistStore
}

export function destructStore(store: Store) {

  return {
    ...store,
    ...storeToRefs(store)
  }
}

export default function setupPinia(app) {
  const pinia = createPinia()
  app.use(pinia)
  pinia.use(piniaPluginPersistedstate)
}